import angular from 'angular';

var buildAliases = buildAliasWithNamespace('@@ulytics');
var ULYTICS_ACTIONS = buildAliases(['ALIAS', 'IDENTIFY', 'PAGE', 'RESET', 'TRACK']);

var createAction = function (type) {
  return function (payload) {
    return { type: type, payload: payload };
  };
};
var createActionFromEventAndData = function (type) {
  return function (event, data) {
    return createAction(type)({ event: event, data: data });
  };
};
var alias = createAction(ULYTICS_ACTIONS.ALIAS);
var identify = createAction(ULYTICS_ACTIONS.IDENTIFY);
var page = createActionFromEventAndData(ULYTICS_ACTIONS.PAGE);
var reset = function () {
  return { type: ULYTICS_ACTIONS.RESET };
};
var track = createActionFromEventAndData(ULYTICS_ACTIONS.TRACK);

// Build the actions in the form { ALIAS: '{namespace}/ALIAS' }
function buildAliasWithNamespace(namespace) {
  return function (actions) {
    return actions.reduce(function (actions, action) {
      actions[action] = namespace + '/' + action;
      return actions;
    }, {});
  };
}

/**
 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(1);
 * // => false
 */
function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

var isObject_1 = isObject;

/**
 * Converts `value` to an object if it's not one.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {Object} Returns the object.
 */
function toObject(value) {
  return isObject_1(value) ? value : Object(value);
}

var toObject_1 = toObject;

/**
 * Creates a base function for `_.forIn` or `_.forInRight`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var iterable = toObject_1(object),
        props = keysFunc(object),
        length = props.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      var key = props[index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var createBaseFor_1 = createBaseFor;

/**
 * The base implementation of `baseForIn` and `baseForOwn` which iterates
 * over `object` properties returned by `keysFunc` invoking `iteratee` for
 * each property. Iteratee functions may exit iteration early by explicitly
 * returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor_1();

var baseFor_1 = baseFor;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var baseProperty_1 = baseProperty;

/**
 * Gets the "length" property value of `object`.
 *
 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
 * that affects Safari on at least iOS 8.1-8.3 ARM64.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {*} Returns the "length" value.
 */
var getLength = baseProperty_1('length');

var getLength_1 = getLength;

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength;

/**
 * Checks if `value` is array-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 */
function isArrayLike(value) {
  return value != null && isLength_1(getLength_1(value));
}

var isArrayLike_1 = isArrayLike;

/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike;

/** Used for native method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Native method references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is classified as an `arguments` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  return isObjectLike_1(value) && isArrayLike_1(value) &&
    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
}

var isArguments_1 = isArguments;

/** `Object#toString` result references. */
var funcTag = '[object Function]';

/** Used for native method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString = objectProto$1.toString;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in older versions of Chrome and Safari which return 'function' for regexes
  // and Safari 8 which returns 'object' for typed array constructors.
  return isObject_1(value) && objToString.call(value) == funcTag;
}

var isFunction_1 = isFunction;

/** Used to detect host constructors (Safari > 5). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for native method references. */
var objectProto$2 = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var fnToString = Function.prototype.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  fnToString.call(hasOwnProperty$1).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * Checks if `value` is a native function.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
 * @example
 *
 * _.isNative(Array.prototype.push);
 * // => true
 *
 * _.isNative(_);
 * // => false
 */
function isNative(value) {
  if (value == null) {
    return false;
  }
  if (isFunction_1(value)) {
    return reIsNative.test(fnToString.call(value));
  }
  return isObjectLike_1(value) && reIsHostCtor.test(value);
}

var isNative_1 = isNative;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = object == null ? undefined : object[key];
  return isNative_1(value) ? value : undefined;
}

var getNative_1 = getNative;

/** `Object#toString` result references. */
var arrayTag = '[object Array]';

/** Used for native method references. */
var objectProto$3 = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString$1 = objectProto$3.toString;

/* Native method references for those with the same name as other `lodash` methods. */
var nativeIsArray = getNative_1(Array, 'isArray');

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(function() { return arguments; }());
 * // => false
 */
var isArray = nativeIsArray || function(value) {
  return isObjectLike_1(value) && isLength_1(value.length) && objToString$1.call(value) == arrayTag;
};

var isArray_1 = isArray;

/** Used to detect unsigned integer values. */
var reIsUint = /^\d+$/;

/**
 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
 * of an array-like value.
 */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;
  return value > -1 && value % 1 == 0 && value < length;
}

var isIndex_1 = isIndex;

/** Used for native method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$4.hasOwnProperty;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  if (object == null) {
    return [];
  }
  if (!isObject_1(object)) {
    object = Object(object);
  }
  var length = object.length;
  length = (length && isLength_1(length) &&
    (isArray_1(object) || isArguments_1(object)) && length) || 0;

  var Ctor = object.constructor,
      index = -1,
      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
      result = Array(length),
      skipIndexes = length > 0;

  while (++index < length) {
    result[index] = (index + '');
  }
  for (var key in object) {
    if (!(skipIndexes && isIndex_1(key, length)) &&
        !(key == 'constructor' && (isProto || !hasOwnProperty$2.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var keysIn_1 = keysIn;

/**
 * The base implementation of `_.forIn` without support for callback
 * shorthands and `this` binding.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForIn(object, iteratee) {
  return baseFor_1(object, iteratee, keysIn_1);
}

var baseForIn_1 = baseForIn;

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for native method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$5.hasOwnProperty;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objToString$2 = objectProto$5.toString;

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * **Note:** This method assumes objects created by the `Object` constructor
 * have no inherited enumerable properties.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  var Ctor;

  // Exit early for non `Object` objects.
  if (!(isObjectLike_1(value) && objToString$2.call(value) == objectTag && !isArguments_1(value)) ||
      (!hasOwnProperty$3.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
    return false;
  }
  // IE < 9 iterates inherited properties before own properties. If the first
  // iterated property is an object's own property then there are no inherited
  // enumerable properties.
  var result;
  // In most environments an object's own properties are iterated before
  // its inherited properties. If the last iterated property is an object's
  // own property then there are no inherited enumerable properties.
  baseForIn_1(value, function(subValue, key) {
    result = key;
  });
  return result === undefined || hasOwnProperty$3.call(value, result);
}

var isPlainObject_1 = isPlainObject;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

// Used internally, but exporting for testing
var SANITIZED_VALUE$$1 = '[SANITIZED]';

// Sanitizes sensitive properties like passwords and whatever else is set in
// the SANITIZE_PROPERTIES constant
var sanitizeObject$$1 = function (sanitizePropertiesList) {
  return function (obj) {
    var sanitized = isPlainObject_1(obj) ? _extends({}, obj) : {};
    sanitizePropertiesList.forEach(function (property) {
      if (sanitized.hasOwnProperty(property)) {
        sanitized[property] = SANITIZED_VALUE$$1;
      }
    });
    return sanitized;
  };
};

// All utils should be exported from this file whether it's

reduxUIRouterEpic.$inject = ['$location', '$timeout'];

function reduxUIRouterEpic($location, $timeout) {
  'ngInject';

  return function (_ref, _ref2) {
    var type = _ref.type,
        payload = _ref.payload;
    var dispatch = _ref2.dispatch,
        getState = _ref2.getState;

    var callIfFunction = function (fn) {
      return isFunction_1(fn) ? fn(getState()) : fn;
    };

    if (type === '@@reduxUiRouter/$stateChangeSuccess') {
      // Need the $timeout so that window.location is set properly prior
      // to dispatching the page event. Looks like the URL isn't updated
      // until after the notification.
      //  https://github.com/angular-ui/ui-router/blob/legacy/src/state.js#L1181
      //
      // Also see.
      //    https://github.com/angular-ui/ui-router/issues/2807
      //    https://github.com/angular-ui/ui-router/issues/3015
      return $timeout(function () {
        return handleReduxUiRouterPage(payload);
      });
    }

    function handleReduxUiRouterPage(_ref3) {
      var currentState = _ref3.currentState;
      var _currentState$analyti = currentState.analytics,
          analytics = _currentState$analyti === undefined ? {} : _currentState$analyti;

      if (!currentState.abstract && !analytics.ignore) {
        var pageTitle = callIfFunction(analytics.page || currentState.title) || $location.path();
        var pageProps = callIfFunction(analytics.properties) || {};
        dispatch(page(pageTitle, pageProps));

        if (analytics.engagement) {
          dispatch(track(analytics.engagement + ' Engagement', pageProps));
        }
      }
    }
  };
}

var ANALYTICS_METHODS = ['trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview', 'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug', 'page', 'once', 'off', 'on'];

function loadAnalyticsJsFromWindow(window) {
  // Taken from segment.com and slightly modified (mostly ES5 -> ES6 tweaks)
  // https://segment.com/docs/sources/website/analytics.js/quickstart/#step-1-copy-the-snippet
  return function loadAnalyticsJs(segmentWriteKey) {
    var segmentLoadOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // Create a queue, but don't obliterate an existing one!
    var analytics = window.analytics = window.analytics || [];

    // If the real analytics.js is already on the page return.
    if (analytics.initialize) return analytics;

    // If the snippet was invoked already show an error.
    if (analytics.invoked) {
      if (window.console && console.error) {
        console.error('Segment snippet included twice.');
      }
      return analytics;
    }

    // Invoked flag, to make sure the snippet
    // is never invoked twice.
    analytics.invoked = true;

    // A list of the methods in Analytics.js to stub.
    analytics.methods = ANALYTICS_METHODS;

    // Define a factory to create stubs. These are placeholders
    // for methods in Analytics.js so that you never have to wait
    // for it to load to actually record data. The `method` is
    // stored as the first argument, so we can replay the data.
    analytics.factory = function (method) {
      return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        window.analytics.push([method].concat(args));
        return analytics;
      };
    };

    // For each of our methods, generate a queueing stub.
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = ANALYTICS_METHODS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var method = _step.value;

        analytics[method] = analytics.factory(method);
      }

      // Define a method to load Analytics.js from our CDN,
      // and that will be sure to only ever load it once.
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    analytics.load = function (key, options) {
      // Create an async script element based on your key.
      var script = document.createElement('script');
      script.onload = function () {
        window.upd_segment_loaded = true;
      };
      script.type = 'text/javascript';
      script.async = true;
      script.src = '//cdn.segment.com/analytics.js/v1/' + key + '/analytics.min.js';

      // Insert our script next to the first script element.
      var first = document.getElementsByTagName('script')[0];
      first.parentNode.insertBefore(script, first);
      analytics._loadOptions = options;
    };

    // Add a version to keep track of what's in the wild.
    analytics.SNIPPET_VERSION = '4.1.0';

    // Load Analytics.js with your key, which will automatically
    // load the tools you've enabled for your account. Boosh!
    analytics.load(segmentWriteKey, segmentLoadOptions);

    return analytics;
  };
}

// Have to handle resetting integrations independently since Segment only resets
// their own cookies. Not sure why, since this seems to defeat the purpose of
// Segment.
// https://segment.com/docs/libraries/analytics.js/#reset-logout
function resetIntegrations(window) {
  var resetFullStory = function () {
    var FS = window.FS;

    if (FS && isFunction_1(FS.clearUserCookie)) {
      // Only clear cookies for previously identified users
      // http://help.fullstory.com/develop-js/172239
      FS.clearUserCookie(true);
    }
  };

  resetFullStory();
}

UlyticsMiddlewareService.$inject = ['$q', '$window', 'ULYTICS_CONFIG'];

function determineStaticPropertiesSelector(selector) {
  var defaultSelector = function () {
    return {};
  };
  return isFunction_1(selector) ? selector : defaultSelector;
}

function UlyticsMiddlewareService($q, $window, ULYTICS_CONFIG) {
  'ngInject';

  var loadAnalyticsJs = loadAnalyticsJsFromWindow($window);
  var segmentWriteKey = ULYTICS_CONFIG.segmentWriteKey,
      segmentLoadOptions = ULYTICS_CONFIG.segmentLoadOptions,
      getStaticPropertiesSelector = ULYTICS_CONFIG.getStaticPropertiesSelector,
      _ULYTICS_CONFIG$ignor = ULYTICS_CONFIG.ignoreActions,
      ignoreActions = _ULYTICS_CONFIG$ignor === undefined ? [] : _ULYTICS_CONFIG$ignor;

  var getStaticProperties = determineStaticPropertiesSelector(getStaticPropertiesSelector);

  var analyticsJs = loadAnalyticsJs(segmentWriteKey, segmentLoadOptions);

  /* eslint-disable no-fallthrough */
  return function (_ref) {
    var getState = _ref.getState;
    return function (next) {
      return function (action) {
        var ret = next(action);

        var mergeWithStaticProperties = function (properties) {
          return _extends({}, getStaticProperties(getState()), properties);
        };

        var type = action.type,
            payload = action.payload;


        switch (type) {
          case ULYTICS_ACTIONS.ALIAS:
            return analyticsJs.alias(payload);

          case ULYTICS_ACTIONS.IDENTIFY:
            return analyticsJs.identify(payload.id, mergeWithStaticProperties(payload.traits));

          case ULYTICS_ACTIONS.RESET:
            analyticsJs.reset();
            return resetIntegrations($window);

          case ULYTICS_ACTIONS.PAGE:
            if (!ignoreActions.includes(ULYTICS_ACTIONS.PAGE)) {
              return analyticsJs.page(payload.event, mergeWithStaticProperties(payload.data));
            }

          case ULYTICS_ACTIONS.TRACK:
            if (!ignoreActions.includes(ULYTICS_ACTIONS.TRACK)) {
              return analyticsJs.track(payload.event, mergeWithStaticProperties(payload.data));
            }

          default:
            return ret;
        }
        /* eslint-disable */
      };
    };
  };
}

var ULYTICS_MIDDLEWARE = 'UlyticsMiddleware';
var UlyticsMiddlewareModule = angular.module('ulytics.middleware', []).service(ULYTICS_MIDDLEWARE, UlyticsMiddlewareService);

AnalyticsOnDirective.$inject = ['$interpolate', 'UlyticsStore'];

function AnalyticsOnDirective($interpolate, UlyticsStore) {
  'ngInject';

  return {
    restrict: 'A',
    link: {
      // Using pre-link function here specifically so this executes prior to
      // any other directive, including children. This is important to ensure
      // that whatever event we're binding to (i.e. click, blur, etc.) happens
      // before core directives (i.e. ng-click, ng-blur) or when using
      // `replace: true` as in angular-material components. We want to do this
      // so we preserve the order the events are tracked.
      pre: preLink
    }
  };

  function preLink(scope, element, attrs) {
    var analyticsOn = attrs.analyticsOn,
        analyticsIf = attrs.analyticsIf,
        analyticsEvent = attrs.analyticsEvent,
        analyticsProperties = attrs.analyticsProperties;

    var defaultAttrs = ['', 'analytics-on'];
    var bindEvent = defaultAttrs.indexOf(analyticsOn) > -1 ? 'click' : analyticsOn;
    var eventName = analyticsEvent || getEventName(element);

    element.on(bindEvent, handleEvent);

    function handleEvent(_ref) {
      var type = _ref.type;

      // Allow the event to be canceled via analytics-if attribute
      if (analyticsIf && !scope.$eval(analyticsIf)) {
        return;
      }

      var props = { 'Event Type': type };
      if (analyticsProperties) {
        Object.assign(props, scope.$eval(analyticsProperties));
      }

      // If the string includes the beginning of an angular expression then
      // interpolate it. There is no reason to interpolate the string otherwise.
      if (eventName.includes('{{')) {
        eventName = $interpolate(eventName)(scope);
      }

      UlyticsStore.dispatch(track(eventName, props));
    }
  }

  function isCommand(element) {
    var name = element.prop('tagName').toLowerCase();
    var type = element.prop('type') || '';
    var commands = ['a:', 'button:', 'button:button', 'button:submit', 'input:button', 'input:submit'];
    return commands.indexOf(name + ':' + type) > -1;
  }

  function getEventName(element) {
    return isCommand(element) ? element.text() || element.val() : element.attr('id') || element.prop('tagName');
  }
}

UlyticsStoreService.$inject = ['$injector', 'ULYTICS_CONFIG'];
function UlyticsStoreService($injector, ULYTICS_CONFIG) {
  'ngInject';

  var storeServiceName = ULYTICS_CONFIG.storeServiceName;

  if (!storeServiceName) {
    throw new Error('[Ulytics] No ULYTICS_CONFIG.storeServiceName defined');
  }
  return $injector.get(storeServiceName);
}

var UlyticsStoreModule = angular.module('ulytics.store', []).service('UlyticsStore', UlyticsStoreService);

var AnalyticsOnModule = angular.module('ulytics.directive', [UlyticsStoreModule.name]).directive('analyticsOn', AnalyticsOnDirective);

UlyticsInterceptorService.$inject = ['$q', '$injector'];

function UlyticsInterceptorService($q, $injector) {
  'ngInject';

  var SANITIZE_PROPERTIES = ['password'];
  var sanitize = sanitizeObject$$1(SANITIZE_PROPERTIES);

  return {
    responseError: function (rejection) {
      TrackError(rejection);
      // Don't throw since Angular < 1.6 treats thrown exceptions differently
      // than returning $q.reject() within onFulfilled and onRejection handlers.
      // TODO: When we upgrade to AngularJS 1.6 we should be able to
      //       just `throw rejection` here.
      return $q.reject(rejection);
    }
  };

  function TrackError() {
    var res = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var status = res.status;
    var config = res.config || {};
    var data = res.data || {};
    // TODO: Allow sanitized properties to be configured by the app
    var body = sanitize(config.data);
    var properties = {
      'Status Code': status,
      'Status Text': res.statusText,
      'Error': data.error,
      'Request URL': config.url,
      'Request Method': config.method,
      'Request Body': JSON.stringify(body)
    };

    getUlyticsStore().dispatch(track('Received API Error - ' + status, properties));
  }

  function getUlyticsStore() {
    // Using the injector here so we don't run into a circular dependency
    return $injector.get('UlyticsStore');
  }
}

UlyticsInterceptorConfig.$inject = ['$httpProvider'];

var ULYTICS_INTERCEPTOR = 'UlyticsInterceptor';

var UlyticsInterceptorModule = angular.module('ulytics.interceptor', [UlyticsStoreModule.name]).config(UlyticsInterceptorConfig).service(ULYTICS_INTERCEPTOR, UlyticsInterceptorService);

function UlyticsInterceptorConfig($httpProvider) {
  'ngInject';

  $httpProvider.interceptors.push(ULYTICS_INTERCEPTOR);
}

var UlyticsModule = angular.module('ulytics', [AnalyticsOnModule.name, UlyticsInterceptorModule.name, UlyticsMiddlewareModule.name]);

export { ULYTICS_ACTIONS, alias, identify, page, reset, track, reduxUIRouterEpic, ULYTICS_MIDDLEWARE, UlyticsMiddlewareModule, UlyticsModule };
